import { Field, EndingField, WelcomeField, DescriptionField } from 'types/domain'
import { omit } from 'lodash-es'

export function getImage(field: Field) {
  if (!field.image) {
    return null
  }
  return omit(field?.image, ['url'])
}
